module.exports = "/images/play-again.png?27c467523c68610b002aeec93087dee2";